// extracted by mini-css-extract-plugin
module.exports = {"Subheading":"Subheading_Subheading__UzK_l"};